export function getEditionsTableEmptyStateTitle(timespan: string) {
    const days = timespan.match(/\d+/);
    if (days) {
        return `No broadcasts or newsletters in last ${days[0]} days`;
    }

    return 'No broadcasts or newsletters have been sent';
}
